<h2 mat-dialog-title>Desafiliación</h2>
<mat-dialog-content class="mat-typography">
  <h3>¿Está seguro de que desea desafiliar un medio de acceso {{data.numeroTarjeta}}?</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Desafiliar</button>
</mat-dialog-actions>